import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ForgeTextField } from '@tylertech/forge-react';
import { REQUIRED_FIELD_TEXT, SUPPORT_SLOT } from '../../../static/constants.js';
import { createRandomID } from '../reusableFunctions.js';

const TextFieldWrapper = ({
  label = 'Label',
  accLabel = label,
  value,
  invalid = false,
  isTextArea = false,
  required = false,
  popoverIcon = false,
  showClear = false,
  disabled = false,
  floatLabel = false,
  childrenBeforeInput = false,
  inputId = `text-field-wrapper-${label.replaceAll(' ', '-').toLowerCase()}-${createRandomID()}`,
  htmlFor = inputId,
  style = {},
  inputType = 'text', 
  supportSlot = SUPPORT_SLOT,
  supportSlotEnd = 'support-text-end',
  supportTextClassName = 'invalid',
  textFieldClassName = 'text-field-wrapper',
  supportText = REQUIRED_FIELD_TEXT,
  supportTextEnd = '',
  onChange = () => { },
  setHasInteracted = () => { },
  children = null,
  showSupportTextAlways = false,
  showSupportTextEndAlways = false,
  variant,
  skipIsTouched = false,
  name,
}) => {
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    setHasInteracted(isTouched);
  }, [isTouched]);
  return (
    <ForgeTextField
      required={required}
      invalid={Boolean(invalid && isTouched) || Boolean(invalid && skipIsTouched)}
      disabled={disabled}
      floatLabel={floatLabel}
      className={textFieldClassName}
      popoverIcon={popoverIcon}
      showClear={showClear}
      on-forge-text-field-clear={() => setIsTouched(true)}
      style={style}
      variant={variant}
    >
      {childrenBeforeInput ? children : null}
      {label ? <label htmlFor={htmlFor.replaceAll(' ', '-').toLowerCase()} >{label}</label> : null}
      {isTextArea
        ?
        <textarea
          style={{ resize: 'vertical' }}
          autoComplete="one-time-code"
          id={inputId.replaceAll(' ', '-').toLowerCase()}
          type={inputType}
          value={value}
          onChange={(e) => {
            onChange(e);
            !isTouched && setIsTouched(true);
          }}
          onBlur={() => !isTouched && setIsTouched(true)}
        />
        :
        <input
          autoComplete="one-time-code"
          name={name || label}
          {...(label.length === 0 && { 'aria-label': accLabel })}
          id={inputId.replaceAll(' ', '-').toLowerCase()}
          type={inputType}
          value={value}
          onChange={(e) => {
            onChange(e);
            !isTouched && setIsTouched(true);
          }}
          onBlur={() => !isTouched && setIsTouched(true)}
        />
      }
      {!childrenBeforeInput ? children : null}
      {((invalid || showSupportTextAlways) && (isTouched || skipIsTouched)) && supportText.length ? (
        <span className={supportTextClassName} slot={supportSlot}>
          {supportText}
        </span>
      ) : null}
      {(((invalid && (isTouched || skipIsTouched)) || showSupportTextEndAlways)) && supportTextEnd.length ? (
        <span className={isTouched || skipIsTouched ? supportTextClassName : ''} slot={supportSlotEnd}>
          {supportTextEnd}
        </span>
      ) : null}    </ForgeTextField>
  );
};

TextFieldWrapper.propTypes = {
  label: PropTypes.string,
  accLabel: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  invalid: PropTypes.bool,
  isTextArea: PropTypes.bool,
  required: PropTypes.bool,
  popoverIcon: PropTypes.bool,
  showClear: PropTypes.bool,
  disabled: PropTypes.bool,
  floatLabel: PropTypes.bool,
  childrenBeforeInput: PropTypes.bool,
  inputId: PropTypes.string,
  htmlFor: PropTypes.string,
  style: PropTypes.object,
  inputType: PropTypes.string,
  supportSlot: PropTypes.string,
  supportSlotEnd: PropTypes.string,
  supportTextClassName: PropTypes.string,
  supportText: PropTypes.string,
  supportTextEnd: PropTypes.string,
  onChange: PropTypes.func,
  setHasInteracted: PropTypes.func,
  textFieldClassName: PropTypes.string,
  children: PropTypes.node,
  showSupportTextAlways: PropTypes.bool,
  showSupportTextEndAlways: PropTypes.bool,
  variant: PropTypes.string,
  skipIsTouched: PropTypes.bool,
  name: PropTypes.string,
};

export default TextFieldWrapper;
